export default defineNuxtPlugin(() => {})

declare global {
    interface Window { zebline: any; }
}
export {}